
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class extends Vue {
  @Prop() item!: any;
  @Prop({ default: 1 }) divisor!: number;
  @Prop() unit!: string;
  @Prop() rLable!: string;
  @Prop() title!: string;
  @Prop() msgId!: number;
  @Prop({ default: 999999 }) max!: number;
  @Prop({ default: [] }) provinceList!: any;
  @Prop({ default: '' }) type!: string;
  @Prop() getProvinceName!: Function;
}
